import { render, staticRenderFns } from "./SlOption.vue?vue&type=template&id=2c007a8e&scoped=true&"
import script from "./SlOption.vue?vue&type=script&lang=js&"
export * from "./SlOption.vue?vue&type=script&lang=js&"
import style0 from "./SlOption.vue?vue&type=style&index=0&id=2c007a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c007a8e",
  null
  
)

export default component.exports